export default "__VITE_ASSET__6e0809e9__"